<template>
	<div class="phone-box">
		<div class="empty" v-if="designs.length === 0">
			<!-- <img src="@/assets/logo.png" /> -->
			<p>点击下方按钮，打开组件库</p>
		</div>

		<draggable
			:list="designs"
			class="list-group"
			ghost-class="ghost"
			:move="checkMove"
			@start="dragging = true"
			@end="dragging = false"
		>
			<div
				v-for="(designData, index) in designs"
				class="component"
				:class="editing.comfirm && editing.comfirm.id == editing.id ? 'r-box' : editing == designData ? 'b-box' : ''"
				:is="designData.preview"
				:key="index"
				:data="designData.data"
				:style="{ borderColor:designData.confirm ?  'red' : ''}"
				:setting="designData.setting"
				@click.native="handleClick(designData)"
				@mouseenter.native.self="handleMouseOver($event, designData, index)"
				@mouseleave.native.self="handleMouseOut"
			>
				<i slot="close" class="el-icon-close close-btn hover-show" @click.stop="handleTimesClick"></i>
			</div>
		</draggable>
		<slot name="add"></slot>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
	name: 'PhoneBox',
	components: {
		draggable
	},
	props: {
		designs: Array,
		editing: Object
	},
	data: function () {
		return {
			ctrlBox: {
				top: 0,
				show: false,
				showUpBtn: true,
				showDownBtn: true,
				targetDesign: null,
				dragging: false
			}
		}
	},
	methods: {
		handleClick: function (designData) {
			// console.log(designData)
			this.$emit('click', designData, false)
		},
		handleMouseOver: function (event, designData, index) {
			this.ctrlBox.top = event.target.offsetTop
			this.ctrlBox.show = true
			this.ctrlBox.showUpBtn = index !== 0
			this.ctrlBox.showDownBtn = index !== this.designs.length - 1
			this.ctrlBox.targetDesign = designData
		},
		handleMouseOut: function () {
			this.ctrlBox.show = false
		},
		handleCtrlBoxMouseOver: function () {
			this.ctrlBox.show = true
		},
		handleCtrlBoxMouseOut: function () {
			this.ctrlBox.show = false
		},
		handleUpClick: function () {
			let index = this.designs.indexOf(this.ctrlBox.targetDesign)
			let thisDesign = this.designs[index]
			let prevDesign = this.designs[index - 1]
			this.$set(this.designs, index, prevDesign)
			this.$set(this.designs, index - 1, thisDesign)
			this.ctrlBox.show = false
		},
		handleDownClick: function () {
			let index = this.designs.indexOf(this.ctrlBox.targetDesign)
			let thisDesign = this.designs[index]
			let nextDesign = this.designs[index + 1]
			this.$set(this.designs, index, nextDesign)
			this.$set(this.designs, index + 1, thisDesign)
			this.ctrlBox.show = false
		},
		handleTimesClick: function () {
			// MessageBox.confirm('确定要删除此模块吗？', '提示', { type: 'warning' }).then(() => {
			this.designs.splice(this.designs.indexOf(this.ctrlBox.targetDesign), 1)
			this.ctrlBox.show = false
			if (this.designs.length) {
				this.handleClick(this.designs[0])
			} else {
				this.handleClick(false)
			}
		},
		checkMove: function (e) {
			window.console.log('Future index: ' + e.draggedContext.futureIndex)
		}
	}
}
</script>
<style lang="scss" scoped>
.phone-box {
	position: relative;
	height: calc(100% - 84px);
	width: 378px;
	background-color: #eeeff4;
	box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
		rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
	overflow-x: hidden;
	border-radius: 24px 24px 0 0;
}
// .phone-box::-webkit-scrollbar {
//   display: none;
// }

.phone-menu {
	position: relative;
	text-align: center;
	font-size: 16px;
	color: #fff;
	background: #1f2d3d;
	height: 41.5px;
	line-height: 41.5px;
}

.phone-menu img {
	display: block;
	position: absolute;
	right: 12px;
	top: 9px;
	width: 80px;
}
.empty {
	text-align: center;
	font-size: 12px;
	margin-top: 150px;
	color: #324057;
}
.empty img {
	margin: auto;
	display: block;
	width: 120px;
}
.empty p {
	margin-top: 2em;
}

.component {
	position: relative;
	cursor: pointer;
	margin: 0px 0px 0px 0px;
	top: 64px;
	border: 1px solid #e5e5e5;
	border-left: 1px solid transparent;
	border-right: 1px solid transparent;
	border-top: 1px solid transparent;
	&:hover {
		.hover-show {
			display: inline-block;
		}
		border: 1px dashed #1684fc;
	}

	&.b-box {
		border: 1px solid #1684fc;
		.hover-show {
			display: inline-block;
		}
		border: 1px solid #1684fc;
	}
	&.r-box {
		border: 1px solid red;
		.hover-show {
			display: inline-block;
		}
		border: 1px solid red;
	}
}
</style>
